import React, { ReactElement } from 'react';
import IconButton from '@material-ui/core/IconButton';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

type Props = {
  onZoomToFit: () => void;
};

function CameraControls(props: Props): ReactElement {
  function onOpenDocumentationClick() {
    window.open('/potterware-documentation/', '_blank');
  }

  return (
    <div className="camera-controls">
      <IconButton
        aria-label="upload picture"
        component="span"
        onClick={props.onZoomToFit}
      >
        <CenterFocusStrongIcon fontSize="large" />
      </IconButton>

      <IconButton
        aria-label="open documentation"
        component="span"
        onClick={onOpenDocumentationClick}
      >
        <HelpOutlineIcon fontSize="large" />
      </IconButton>
    </div>
  );
}

export default CameraControls;
